export const postsConstants = {
    GETPOSTS_SUCCES: 'GET_POSTS_SUCCES',
    CREATEPOST_SUCCES: 'CREATE_POST_SUCCES',
    GETPOST_SUCCES: 'GET_POST_SUCCES',
    UPDATEPOST_SUCCES: 'UPDATE_POST_SUCCES'
};
